//imports
import React, { useEffect, useMemo, useState } from "react";
import config from "../../../config";
import axios from "axios";
import {
  FaMoneyBill,
  FaChartBar,
  FaUserCircle,
  FaRegCheckSquare,
} from "react-icons/fa";
import ClipLoader from "react-spinners/ClipLoader";

//import Components
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
//import Pages
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import Pie from "../../../components/Dashboard/Charts/piechart";
import BarChart from "../../../components/Dashboard/Charts/barchart";

import { AuthService } from "../../../services/auth";
import httpClient from "../../../services/httpClient";
const authService = new AuthService(httpClient);

const Demo = () => {
  // meta title
  document.title = "[Demo]Dashboard | Zayon AI-Driven Decision Making";

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [check, setCheck] = useState(false);
  const [idParams, setIdParams] = useState(null);

  useMemo(() => {
    const url_string = window.location.href;
    const url = new URL(url_string);
    const userIdParams = url.searchParams.get("id");
    setIdParams(userIdParams);
  }, []);

  useEffect(() => {
    if (idParams) {
      const token = localStorage.getItem('authUser');
      const fetchData = () => {
        axios.get(`${config.apiUrl}/api/compliance/${idParams}`, {
          headers: {
            "Authorization": `Bearer ${token}`
          }
        })
          .then((response) => {
            setData(response.data);
            setCheck(true);
            setLoading(false);
          })
          .catch((error) => {
            setError(error);
            setLoading(false);
          });
      };

      fetchData();
    }
  }, [idParams]);

  const formatCurrency = (value) => {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(value);
  };

  // Verifique se os dados foram carregados antes de renderizar
  if (loading) {
    return (
      <div className="page-content">
        <ClipLoader
          color={"#FFF"}
          loading={loading}
          cssOverride={{
            display: "block",
            margin: "0 auto",
            borderColor: "red",
          }}
          size={150}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>
    );
  }

  if (!data || !data.analise) {
    return <div>Error: Dados não disponíveis</div>;
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Breadcrumbs title="Dashboard" breadcrumbItem="Análise de dados" />
        <Container fluid={true}>
          <Row>
            {/* Total Caixa */}
            <Col lg={3}>
              <Card className="bg-secondaryOpacity border-secondaryOpacity">
                <CardBody>
                  <FaMoneyBill size={36} />
                  <h5 className="my-3">Total Caixa</h5>
                  <p className="card-text">
                    {formatCurrency(
                      !data.analise.caixa_gerado ? "---" : data?.analise.caixa_gerado
                    )}
                  </p>
                </CardBody>
              </Card>
            </Col>
            {/* Rentabilidade */}
            <Col lg={3}>
              <Card className="bg-secondaryOpacity border-secondaryOpacity">
                <CardBody>
                  <FaChartBar size={36} />
                  <h5 className="my-3">Rentabilidade</h5>
                  <p className="card-text">
                    {`${!data.analise.rentabilidade ? "---" : `${data.analise.rentabilidade.toFixed(2)}%`}`}
                  </p>
                </CardBody>
              </Card>
            </Col>
            {/* Produtos vendidos */}
            <Col lg={3}>
              <Card className="bg-secondaryOpacity border-secondaryOpacity">
                <CardBody>
                  <FaUserCircle size={36} />
                  <h5 className="my-3">Produtos vendidos</h5>
                  <p className="card-text">
                    {`${!data.analise.quantidade_produto_vendido ? "---" : data.analise.quantidade_produto_vendido.toFixed(0)}`}
                  </p>
                </CardBody>
              </Card>
            </Col>
            {/* Vendas Realizadas */}
            <Col lg={3}>
              <Card className="bg-secondaryOpacity border-secondaryOpacity">
                <CardBody>
                  <FaRegCheckSquare size={36} />
                  <h5 className="my-3">Vendas Realizadas</h5>
                  <p className="card-text">{data.analise.vendas_realizadas} </p>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col lg="3">
              <Card className="bg-secondaryOpacity border-secondaryOpacity">
                <CardHeader className="bg-secondaryOpacity">
                  <h5 className="mb-0">Composição do Faturamento</h5>
                </CardHeader>
                <CardBody>
                  <div id="pie-chart" className="e-chart">
                    <Pie
                      labels={["Produtos", "Serviços"]}
                      data={[data.analise.caixa_gerado_produtos, data.analise.caixa_gerado_servicos]}
                      colors={["#AA15E7", "#FA9AC1"]}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col className="w-100">
              <Card className="bg-secondaryOpacity border-secondaryOpacity">
                <CardHeader className="bg-secondaryOpacity">
                  <h5 className="mb-0">Receita por mês</h5>
                </CardHeader>
                <CardBody>
                  <BarChart
                    color={"#422A80"}
                    hover={"#826ACA"}
                    labels={data.analise.receita_por_mes.map((item) => `${item.Mês}/${item.Ano}`)}
                    dados={data.analise.receita_por_mes.map((item) => item["Valor Contábil"])}
                  />
                </CardBody>
              </Card>
            </Col>
            {/* <Col className="w-100">
                <Card className="bg-secondaryOpacity border-secondaryOpacity">
                  <CardHeader className="bg-secondaryOpacity">
                    <h5 className="mb-0">Produtos mais rentáveis</h5>
                  </CardHeader>
                  <CardBody>
                    <BarChart
                      color={"#972A6C"}
                      hover={"#826ACA"}
                      labels={data.analise.faturamento_por_produto.map(
                        (item) => `${item['Nome Produto'].substring(14, 30)}`
                      )}
                      dados={data.analise.faturamento_por_produto.map(
                        (item) => item["Valor Contábil"]
                      )}
                    />
                  </CardBody>
                </Card>
              </Col> */}
          </Row>
          <Row>
            <Col lg="3">
              <Card className="bg-secondaryOpacity border-secondaryOpacity">
                <CardHeader className="bg-secondaryOpacity">
                  <h5 className="mb-0">Receita por trimestre</h5>
                </CardHeader>
                <CardBody>
                  <div id="pie-chart" className="e-chart">
                    <Pie
                      colors={["#AA15E7", "#FA9AC1", "#11FFAA", "#AA88AA"]}
                      labels={data.analise.receita_por_trimestre.map(
                        (item) => `${item['Ano']} - ${item['Trimestre']}`
                      )}
                      data={data.analise.receita_por_trimestre.map(
                        (item) => item["Valor Contábil"]
                      )}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col className="w-100">
              <Card className="bg-secondaryOpacity border-secondaryOpacity">
                <CardHeader className="bg-secondaryOpacity">
                  <h5 className="mb-0">
                    Projeção de receita próximo exercício
                  </h5>
                </CardHeader>
                <CardBody>
                  {<BarChart
                    color={"#004AAD"}
                    hover={"#2271D7"}
                    labels={Object.keys(data.analise.projecao_receita_proximo_exercicio)}
                    dados={Object.values(data.analise.projecao_receita_proximo_exercicio)}
                  />}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container> :
        <div className="page-content">
          <ClipLoader
            color={"#FFF"}
            loading={loading}
            cssOverride={{
              display: "block",
              margin: "0 auto",
              borderColor: "red",
            }}
            size={150}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div>
      </div>
    </React.Fragment>
  );
}

export default Demo;
